<template>
  <div class="container-flight margin_container_hf">
    <flight-search class="search-box" />
    <PDKModal
      :buttonObject="modalButtonProps"
      v-if="showTimerModal"
      @btnAction="onTimeoutModalAction"
    >
      <div style="text-align: center" slot="body">
        <img
          id="timer-logo"
          width="150"
          height="150"
          src="../../../public/img/out-of-ti.png"
        />
        <h4 style="margin-top: 10px">
          زمان شما برای ورود اطلاعات مسافرین به پایان رسیده
        </h4>
      </div>
    </PDKModal>

    <Summary
      v-if="tripType == 2"
      :selectedDeparture="selectedDeparture"
      :selectedReturn="selectedReturn"
    />
    <Summary v-if="tripType == 1" :selectedDeparture="selectedDeparture" />

    <div class="row custom_row">
      <div class="col-md-12">
        <div class="col-md-12">
          <div style="display: flex" class="form_title">
            <div>
              <h3 style="display: flex">
                <strong>
                  <i class="icon-user-1" />
                </strong>
                مشخصات مسافران

                <div style="position: absolute; left: 0">
                  <!-- <span> زمان باقیمانده:</span> -->
                  <vue-countdown-timer
                    style="
                      direction: ltr;
                      font-size: 23px;
                      color: #00c3e1;
                      margin-right: 10px;
                      margin-top: 5px;
                    "
                    @end_callback="endTimeCountdown()"
                    :start-time="startAt"
                    :end-time="endAt"
                    :interval="1000"
                    label-position="begin"
                    :day-txt="null"
                    :hour-txt="null"
                    :seconds-txt="null"
                    :show-zero="true"
                    :end-text="'زمان شما به پایان رسید'"
                  >
                  </vue-countdown-timer>
                </div>
              </h3>

              <p>مشخصات مسافران را به صورت کامل وارد نمائید</p>
            </div>
          </div>

          <div style="padding: 10px 7% 10px 7% !important" class="step">
            <div v-for="(item, index) in passengers" :key="index">
              <div class="custom_form_title form_title">
                <h3 style="font-size: 16px">
                  <strong>
                    <i :class="item.icon"></i>
                  </strong>
                  <div>
                    <span> {{ item.title }} </span>
                    <label style="color: #0a6c9f" v-if="index === 0"
                      >(مسافر اصلی)</label
                    >
                  </div>
                </h3>
                <p>{{ item.subTitle }}</p>
              </div>

              <div class="step">
                <PassengerForm
                  :ageType="item.type"
                  :duplicatedNationalCode="duplicatedNationalCode"
                  :isMainGuest="index === 0"
                  :entriedForm="onEntriedForm(index)"
                  :formId="index"
                  :checkValid="checkValid"
                  @values="onFormValue($event, index)"
                  ref="passengerForm"
                  @isValid="onValidationForm"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <button
            style="height: 35px; margin: auto"
            @click="goNext()"
            class="col-md-4 btn btn-primary"
          >
            گام بعدی
          </button>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import FlightSearch from "./FlightSearch.vue";
import PassengerForm from "./FlightPassengerForm";
import dateUtil from "../../utils/date";
import Summary from "./FlightSummery";
import PDKModal from "@/components/PDKAlertModal";
import Store from "../../views/flight/store/index";
import $ from "jquery";

export default {
  store: Store,
  components: {
    PassengerForm,
    Summary,
    PDKModal,
    FlightSearch,
  },

  watch: {
    isValidForm: function (val) {
      if (val === true) {
        var bookingDetail = this.$store.getters.GetPassengerDetail;

        var passengers = [];

        if (this.passengerForm.length > 0) {
          this.passengerForm.forEach((element) => {
            passengers.push(element.formValues);
          });
        } else if (Object.keys(bookingDetail).length) {
          this.guestRequest = bookingDetail;

          passengers = bookingDetail.passengers;

          bookingDetail.passengers.forEach((element) => {
            var obj = {};
            obj.formValues = element;

            this.passengerForm.push(obj);
          });
        }

        this.passengerDetails = {
          passengers: passengers,
          sourceCode: localStorage.getItem("SourceIdInReport"),
        };

        this.passengerDetails = {
          passengers: passengers,
          sourceCode: localStorage.getItem("SourceIdInReport"),
        };

        this.$store.dispatch("storePassengerDetails", this.passengerDetails);

        var valuesAlreadySeen = [];
        var isBreak = false;
        var isDuplicate = false;
        for (var i = 0; i < this.passengerForm.length; i++) {
          var value = this.passengerForm[i];

          for (var j = 0; j < valuesAlreadySeen.length; j++) {
            if (valuesAlreadySeen[j].formValues.nationalCode !== "") {
              if (
                valuesAlreadySeen[j].formValues.nationalCode ===
                value.formValues.nationalCode
              ) {
                this.duplicatedNationalCode = false;
                isBreak = true;
                isDuplicate = true;
                break;
              } else {
                this.duplicatedNationalCode = true;
              }
            }
          }
          if (!isBreak) {
            valuesAlreadySeen.push(value);
          } else {
            valuesAlreadySeen = [];

            break;
          }
        }

        if (!isDuplicate) {
          this.$router
            .push({
              path: "flightconfirm",
              name: "query",
              query: {
                origin: this.params.origin,
                destination: this.params.destination,
                originName: this.params.originName,
                destinationName: this.params.destinationName,
                fromDate: this.params.fromDate,
                toDate: this.params.toDate,
                adultQty: this.params.adultQty,
                infantQty: this.params.infantQty,
                childQty: this.params.childQty,
                tripType: this.params.tripType,
              },
            })
            .catch(() => {
              // alert("an error occured");
            });
        }
      } else {
        this.checkValid = false;
      }
    },
    checkValid: function (val) {
      return (this.checkValid = val);
    },
    duplicatedNationalCode: function (val) {
      return (this.duplicatedNationalCode = val);
    },
  },

  data() {
    return {
      duplicatedNationalCode: false,
      selectedCip: {},
      passengers: [],
      passengerForm: [],
      modalButtonProps: {
        title: "جستجوی مجدد",
      },
      showTimerModal: false,
      skletonModel: {
        isDeparture: false,
        isReturn: false,
        isToway: false,
        isRoom: false,
        isTotalPrice: false,
      },
      searchItems: {},
      params: {},
      forms: new Array(),
      selectedPackage: {},
      adultCount: 0,
      childCount: 0,
      infantCount: 0,
      endAt: new Date().getTime() + 600000,
      startAt: new Date().getTime(),
      bookingDetails: {},
      guestRequest: "",
      checkValid: false,
      isValidForm: false,

      selectedDeparture: {},
      selectedReturn: {},
      tripType: 1,
    };
  },
  created() {
    window.scrollTo(0, 0);

    this.params = this.$route.query;
    this.duplicatedNationalCode = true;
    this.tripType = parseInt(this.params.tripType);
    const getOneWayFlightSelected = this.$store.getters.GetOneWayFlightSelected;
    const getTwoWayFlightSelected = this.$store.getters.GetTwoWayFlightSelected;

    if (this.tripType === 1) {
      this.selectedDeparture = getOneWayFlightSelected;
    }
    if (this.tripType === 2) {
      this.selectedDeparture = getTwoWayFlightSelected.selectedDeparture;
      this.selectedReturn = getTwoWayFlightSelected.selectedReturn;
    }

    if (
      Object.keys(this.$store.getters.GetOneWayFlightSelected).length == 0 &&
      Object.keys(this.$store.getters.GetOneWayFlightSelected).length == 0
    ) {
      this.onTimeoutModalAction();
    }

    this.getPaxs();

    var bookingDetail = this.$store.getters.GetPassengerDetail;
    if (Object.keys(bookingDetail).length) {
      this.guestRequest = bookingDetail.guestRequest;
    }

    if (!Object.keys(bookingDetail).length) {
      for (var i = 0; i < this.passengers.length; i++) {
        this.passengerForm.push({
          formValues: {
            persianName: "",
            persianFamily: "",
            englishName: "",
            englishFamily: "",
            genderId: "",
            nationalityId: "",
            nationalCode: "",
            birthDate: "",
          },
        });
      }
    }
  },
  computed: {},
  methods: {
    onEntriedForm(indx) {
      this.isValidForm === false;
      this.isValidTransferForm = false;
      var bookingDetail = this.$store.getters.GetPassengerDetail;
      if (Object.keys(bookingDetail).length) {
        return bookingDetail.passengers[indx];
      } else {
        var formValues = {
          mobilePhone: "",
          email: "",
          persianName: "",
          persianFamily: "",
          englishName: "",
          englishFamily: "",
          genderId: "",
          nationalityId: "",
          nationalCode: "",
          birthDate: "",
        };
        return formValues;
      }
    },

    onSelectCip(val) {
      this.selectedCip = val;
    },
    goNext() {
      if (this.isValidForm === false) {
        this.checkValid = !this.checkValid;
      } else {
        this.checkValid = true;
      }
    },
    onValidationForm(val) {
      this.isValidForm = val;
    },
    onFormValue(val, x) {
      this.duplicatedNationalCode = true;
      var bookingDetail = this.$store.getters.GetPassengerDetail;
      if (
        Object.keys(bookingDetail).length &&
        this.passengerForm.length === 0
      ) {
        this.passengerForm = [];
        bookingDetail.passengers.forEach((element) => {
          var obj = {};
          obj.formValues = element;

          this.passengerForm.push(obj);
        });
      }

      if (this.passengerForm.length === 0) {
        for (var i = 0; i < this.passengers.length; i++) {
          this.passengerForm.push({
            formValues: {
              persianName: "",
              persianFamily: "",
              englishName: "",
              englishFamily: "",
              genderId: "",
              nationalityId: "",
              nationalCode: "",
              birthDate: "",
            },
          });
        }
      }
      this.passengerForm[x].formValues = val;
    },
    onTimeoutModalAction() {
      this.$router
        .push({
          name: "flightSearch",
          query: {
            origin: this.params.origin,
            destination: this.params.destination,
            originName: this.params.originName,
            destinationName: this.params.destinationName,
            fromDate: this.params.fromDate,
            toDate: this.params.toDate,
            adultQty: this.params.adultQty,
            infantQty: this.params.infantQty,
            childQty: this.params.childQty,
            tripType: this.params.tripType,
          },
        })
        .catch(() => {});
    },
    endTimeCountdown() {
      this.showTimerModal = true;
    },
    getPaxs() {
      this.adultCount = this.params.adultQty;
      this.infantCount = this.params.infantQty;
      this.childCount = this.params.childQty;

      for (var i = 0; i < this.adultCount; i++) {
        this.passengers.push({
          type: "ADL",
          title: "بزرگسال",
          subTitle: "بزرگتر از 12 سال",
          icon: "icon-adult",
        });
      }
      for (var i = 0; i < this.childCount; i++) {
        this.passengers.push({
          type: "CHL",
          title: "کودک",
          subTitle: "2 تا 12 سال",
          icon: "icon-child",
        });
      }
      for (var i = 0; i < this.infantCount; i++) {
        this.passengers.push({
          type: "INF",
          title: "نوزاد",
          subTitle: "کوچکتر از 2 سال",
          icon: "icon-guest",
        });
      }
    },
  },
  mounted() {
    require("magnific-popup");
    $(this.$el.querySelector("#cip_services")).magnificPopup({
      type: "inline",
      fixedContentPos: true,
      fixedBgPos: true,
      overflowY: "auto",
      closeBtnInside: true,
      preloader: false,
      midClick: true,
      removalDelay: 300,
      mainClass: "my-mfp-zoom-in",
    });
  },
};
</script>
<style scoped>
.custom_form_title h3 strong {
  margin-top: -4px !important;
  margin-right: 3px !important;
  height: 35px !important;
  width: 35px !important;
  background-color: #bdc6cb !important;
}
.custom_form_title {
  margin-bottom: 0px !important;
  padding-right: 45px !important;
}

.custom_row {
  margin-top: 50px;
}
.styled-select {
  background-color: white !important;
  border: 1px solid #ced4da !important;
}
</style>